import React, { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';
import { Nullable } from 'primereact/ts-helpers';

import { DropdownSelectorType } from '../../types/interfaces';
import { TagsComponent } from '../../ui/TagsComponent';
import { PickerTexts } from '../../utils';

interface AssetsMobileFiltersDialogProps {
  visible: boolean;
  onHide: () => void;
  selectedTypeFilter: DropdownSelectorType[];
  assetTypesFilterOptions: DropdownSelectorType[];
  activeFilterActive: Nullable<boolean>;
  onApply: (filters: {
    selectedTypes: DropdownSelectorType[];
    active: Nullable<boolean>;
  }) => void;
  onDeleteTag: (taskId: string | number) => void;
  isMobile: boolean;
}

const AssetsMobileFiltersDialog: React.FC<AssetsMobileFiltersDialogProps> = ({
  visible,
  onHide,
  selectedTypeFilter,
  assetTypesFilterOptions,
  activeFilterActive,
  onApply,
  onDeleteTag,
  isMobile
}) => {
  const [localSelectedTypes, setLocalSelectedTypes] = useState<DropdownSelectorType[]>(selectedTypeFilter);
  const [localActiveFilter, setLocalActiveFilter] = useState<boolean>(activeFilterActive ?? false);

  useEffect(() => {
    if (visible) {
      setLocalSelectedTypes(selectedTypeFilter);
      setLocalActiveFilter(activeFilterActive ?? false);
    }
  }, [visible, selectedTypeFilter, activeFilterActive]);

  const handleApply = () => {
    onApply({
      selectedTypes: localSelectedTypes,
      active: localActiveFilter
    });
    onHide();
  };

  const handleMultiSelectChange = (e: MultiSelectChangeEvent) => {
    setLocalSelectedTypes(e.value);
  };

  const handleActiveChange = (e: CheckboxChangeEvent) => {
    setLocalActiveFilter(e.checked ?? false);
  };

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Фильтры"
      className="mobile-filters-dialog"
      style={{ width: '90vw', maxWidth: '400px' }}
      footer={
        <div className="flex gap-2 mt-2">
          <Button
            label="Применить фильтры"
            className="flex-1"
            onClick={handleApply}
          />
        </div>
      }
    >
      <div className="flex flex-column gap-3 p-2">
        <div className="flex flex-column gap-2">
          <label className="font-semibold text-sm">Типы объектов</label>
          <MultiSelect
            value={localSelectedTypes}
            options={assetTypesFilterOptions}
            onChange={handleMultiSelectChange}
            optionLabel="label"
            fixedPlaceholder
            placeholder={PickerTexts.objectTypes(localSelectedTypes.length)}
            filter
            className={
              localSelectedTypes.length < 1
                ? 'p-invalid assets-header__MultiSelect'
                : 'assets-header__MultiSelect'
            }
            panelClassName="assets-header__customMultiSelect"
            itemClassName="assets-header__customMultiSelect"
          />
        </div>

        <div className="flex align-items-center gap-3 p-2 surface-ground border-round">
          <Checkbox
            id="mobileActiveFilter"
            checked={localActiveFilter}
            onChange={handleActiveChange}
          />
          <label 
            htmlFor="mobileActiveFilter" 
            className="font-semibold text-sm"
            style={{ color: '#6c757d', cursor: 'pointer' }}
          >
            Только активные объекты
          </label>
        </div>

        {localSelectedTypes.length > 0 && (
          <div className="flex flex-column gap-2">
            <label className="font-semibold text-sm">
              Выбранные типы ({localSelectedTypes.length}):
            </label>
            <div 
              style={{ maxHeight: '120px', overflow: 'auto' }}
              className="border-round p-2 surface-ground"
            >
              <TagsComponent
                initialTagsItems={localSelectedTypes}
                onDelete={onDeleteTag}
              />
            </div>
          </div>
        )}

      </div>
    </Dialog>
  );
};

export default AssetsMobileFiltersDialog;